import "./AdminHandleBookings.scss";
import {
  SENIOR_PLAYING_RIGHT,
  inDropInWindow,
} from "../../shared/memberType";
import { useEffect, useRef, useState } from "react";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import RacketIcon from "../../components/UI/icons/RacketIcon";
import {
  IActivity,
  IActivityObject,
  IBooking,
  ICancelBookingInputType,
  ICoach,
  ICoPlayerBooking,
  ICourt,
  ICourtType,
  IDailyComment,
  IInitiateBookingResponse,
  IInitiateBookingSpec,
  IPermission,
  IPrices,
  IRehabSummary,
  IRehabSummaryItem,
  ISummary,
  ISummaryItem,
  IUser,
} from "../../types/api";
import WeekDaySelector from "../../hoc/DatePicker/Datepicker";
import {
  capitalizeWords,
  getMondayOfWeek,
  hardcodeDateIsInRangeApr20Aug21,
} from "../../shared/utility";
import { Auth } from "aws-amplify";
import { Id, toast } from "react-toastify";
import { CognitoUser } from "../../types/cognito";
import CreateBookingPopup from "../../containers/Bookings/CreateBookingPopup/CreateBookingPopup";
import { cancelBooking, initiateBooking } from "../../api/bookings/bookings";
import { searchUsers } from "../../api/users/users";
import { BookingEnum, StatusEnum } from "../../shared/enums";
import { combinedQuery } from "../../api/combinedQueries/combinedQueries";
import { formatDate, formatToIsoDate, isToday } from "../../shared/dateUtils";
import {
  isBefore,
  startOfDay,
  parseISO,
  subDays,
  set,
  getDay,
  addMinutes,
  subMinutes,
  isAfter,
  format,
} from "date-fns";
import Spinner from "../../components/UI/Spinner/Spinner";
import HandleConfirmationPopup from "../../containers/HandleConfirmation/HandleConfirmationPopup";
import ChooseUserPopup from "../../containers/Admin/ChooseUserPopup/ChooseUserPopup";
import AdminHandleBookingPopup from "../../containers/Admin/AdminHandleBookingPopup/AdminHandleBookingPopup";
import CreateActivityPopup from "../../containers/Activities/CreateActivityPopup/CreateActivityPopup";
import { bookActivity } from "../../api/activities/activities";
import BookActivityPopup from "../../containers/Activities/BookHandleActivityPopup/BookHandleActivityPopup";
import HandleRehabTimesPopup from "../../containers/Rehab/HandleRehabTimesPopup/HandleRehabTimesPopup";
import SlotHistoryPopup from "../../containers/SlotHistory/SlotHistoryPopup/SlotHistoryPopup";
import MoveBookingPopup from "../../containers/Bookings/MoveBookingPopup/MoveBookingPopup";
import CreateSlotWarningPopup from "../../containers/SlotHistory/CreateSlotWarningPopup/CreateSlotWarningPopup";
import AdminRehabView from "./AdminRehabView";
import WeekSelector from "../../hoc/DatePicker/Weekpicker";
import RehabSlotHistoryPopup from "../../containers/SlotHistory/RehabSlotHistoryPopup/RehabSlotHistoryPopup";
import EditRehabSlotPopup from "../../containers/Rehab/EditRehabSlotPopup/EditRehabSlotPopup";
import {
  isBookingAllowedForJuniorPlayRight,
  isBookingAllowedForJuniors,
} from "./juniorCheckFunction";
import BokasRemovalPopup from "../../containers/Bookings/BokasRemovalPopup/BokasRemovalPopup";
import CreateBulkWarningPopup from "../../containers/SlotHistory/CreateBulkWarningPopup/CreateBulkWarningPopup";

interface AdminHandleBookingsProps {}

function AdminHandleBookings(props: AdminHandleBookingsProps) {
  const [showBokasRemovalPopup, setShowBokasRemovalPopup] =
    useState<boolean>(false);
  const [selectedSlotToHandle, setSelectedSlotToHandle] =
    useState<ISummaryItem>();
  const [selectedSlotIsSemiNoShow, setSelectedSlotIsSemiNoShow] =
    useState<boolean>(false);
  const [showCreateActivityPopup, setShowCreateActivityPopup] =
    useState<boolean>(false);
  const [showChooseUserPopup, setShowChooseUserPopup] =
    useState<boolean>(false);
  const [showHandleBookingPopup, setShowHandleBookingPopup] =
    useState<boolean>(false);
  const [showSlotHistoryPopup, setShowSlotHistoryPopup] =
    useState<boolean>(false);
  const [showRehabSlotHistoryPopup, setShowRehabSlotHistoryPopup] =
    useState<boolean>(false);

  const [showMoveBookingPopup, setShowMoveBookingPopup] =
    useState<boolean>(false);
  const [showMoveActivitySlotPopup, setShowMoveActivitySlotPopup] =
    useState<boolean>(false);
  const [showCreateSlotWarningPopup, setShowCreateSlotWarningPopup] =
    useState<boolean>(false);
  const [showBulkWarningPopup, setShowBulkWarningPopup] =
    useState<boolean>(false);
  const [rehabSummary, setRehabSummary] = useState<IRehabSummary>();
  const [rehabSummaryWeekly, setRehabSummaryWeekly] =
    useState<IRehabSummary[]>();
  const [showBookRehabPopup, setShowBookRehabPopup] = useState<boolean>(false);
  const [activities, setActivities] = useState<IActivity[]>([]);
  const [timeAndCourtString, setTimeAndCourtString] = useState<string>("");
  const [chosenUser, setChosenUser] = useState<IUser>();
  const [userSummaries, setUserSummaries] = useState<ISummary[]>([]);
  const [coaches, setCoaches] = useState<ICoach[]>();
  const [user, setUser] = useState<CognitoUser | null>(null);
  const [latestCoPlayersForUser, setLatestCoPlayersForUser] = useState<IUser[]>(
    [],
  );
  const [toastIdHistory, setToastIdHistory] = useState<Id | null>(null);
  const [toastIdMarkField, setToastIdMarkField] = useState<Id | null>(null);
  const [toastIdMoveBooking, setToastIdMoveBooking] = useState<Id | null>(null);

  const [searchForCoachOnly, setSearchForCoachOnly] = useState<boolean>(false);

  const [
    selectedSlotsForActivityCreation,
    setSelectedSlotsForActivityCreation,
  ] = useState<
    {
      court_id: string;
      start_time: string;
      end_time: string;
      warning: string;
    }[]
  >([]);
  const [selectedBookedSlotForMovement, setSelectedBookedSlotForMovement] =
    useState<ISummaryItem>();
  const [selectedEmptySlotForMovement, setSelectedEmptySlotForMovement] =
    useState<ISummaryItem>();
  const [selectingBookedSlotForMovement, setSelectingBookedSlotForMovement] =
    useState<boolean>(false);
  const [selectingActivitySlots, setSelectingActivitySlots] =
    useState<boolean>(false);
  const [selectingRehabSlots, setSelectingRehabSlots] =
    useState<boolean>(false);
  const [showEditMarkedRehabSlots, setShowEditMarkedRehabSlots] =
    useState<boolean>(false);
  const [markedRehabSlotsAreReadyForEdit, setMarkedRehabSlotsAreReadyForEdit] =
    useState<boolean>(false);
  const [selectingForHistory, setSelectingForHistory] =
    useState<boolean>(false);
  const [selectingForRehabHistory, setSelectingForRehabHistory] =
    useState<boolean>(false);
  const [selectedSlotForHistory, setSelectedSlotForHistory] =
    useState<ISummaryItem>();
  const [selectedRehabSlotForHistory, setSelectedRehabSlotForHistory] =
    useState<IRehabSummaryItem>();
  const [selectedRehabDateForHistory, setSelectedRehabDateForHistory] =
    useState<Date>();

  const [selectingForRehabSlotEdit, setSelectingForRehabSlotEdit] =
    useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isBookingInitiated, setIsBookingInitiated] = useState(false);
  const isBookingInitiatedRef = useRef(isBookingInitiated);
  useEffect(() => {
    isBookingInitiatedRef.current = isBookingInitiated;
  }, [isBookingInitiated]);
  const [activeActivitiesForUser, setActiveActivitiesForUser] = useState<
    IActivityObject[]
  >([]);
  const [prices, setPrices] = useState<IPrices[]>([]);
  const [showMaxBookingsWarningPopup, setShowMaxBookingsWarningPopup] =
    useState(false);
  const [showNotAvailableForMember, setShowNotAvailableForMember] =
    useState(false);
  const [notAvailableForMemberReason, setNotAvailableForMemberReason] =
    useState<string>("");
  const [permissions, setPermissions] = useState<IPermission[]>([]);
  const [memberType, setMemberType] = useState<IPermission>();
  const [searchString, setSearchString] = useState<string>("");
  // Member ids whose name matches the search term. The summary only stores ids
  // for co-players/guests, so we resolve the typed name into ids and match on
  // those instead of denormalising names onto every booking.
  const [searchedMemberIds, setSearchedMemberIds] = useState<Set<string>>(
    new Set(),
  );
  // Until the name lookup resolves the list only matches on member id, so
  // co-players typed by name look absent. A spinner in the search field says
  // "still catching up" rather than letting that read as "no results".
  const [searchingMembers, setSearchingMembers] = useState<boolean>(false);
  const [currentSelectedCoach, setCurrentSelectedCoach] = useState<ICoach>();
  const [currentCourtType, setCurrentCourtType] =
    useState<ICourtType>("INDOOR");
  const [indoorComment, setIndoorComment] = useState<IDailyComment>();
  const [outdoorComment, setOutdoorComment] = useState<IDailyComment>();
  const [rehabComment, setRehabComment] = useState<IDailyComment>();

  const [activeBookingsForUser, setActiveBookingsForUser] = useState<
    IBooking[]
  >([]);
  const [activeCoPlayerBookingsForUser, setActiveCoPlayerBookingsForUser] =
    useState<ICoPlayerBooking[]>([]);

  const [showBookExtraPopup, setShowBookExtraPopup] = useState<boolean>(false);

  const [showBookActivityPopup, setShowBookActivityPopup] =
    useState<boolean>(false);

  const [courts, setCourts] = useState<ICourt[]>([]);

  const [summaries, setSummaries] = useState<ISummary[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [filterDate, setFilterDate] = useState(() => {
    const storedDate = localStorage.getItem("filterDate");
    const now = formatDate(new Date(), "yyyy-MM-dd");

    return storedDate && new Date(storedDate) >= new Date(now)
      ? new Date(storedDate)
      : new Date(now);
  });

  const [weekFilterDate, setWeekFilterDate] = useState(() => {
    const now = formatDate(new Date(), "yyyy-MM-dd");
    const monday = getMondayOfWeek(new Date(now));
    return monday;
  });

  const [showSemiNoShowWarning, setShowSemiNoShowWarning] =
    useState<boolean>(false);
  const [currentChosenSummaryItem, setCurrentChosenSummaryItem] =
    useState<ISummaryItem>();
  const [bokasSlot, setBokasSlot] = useState<any>();
  const [currentChosenCourt, setCurrentChosenCourt] = useState<ICourt>(
    courts[0],
  );
  const [bookingResponse, setBookingResponse] =
    useState<IInitiateBookingResponse>();
  const [showCreateBookingPopup, setShowCreateBookingPopup] =
    useState<boolean>(false);

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((userData) => {
        setUser(userData);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  }, []);

  // Resolve the typed name into member ids so co-players and guests — which the
  // summary only stores as ids — can be matched by name. Debounced, and skipped
  // entirely for coach-only search or short/numeric terms (those already match
  // locally by id).
  useEffect(() => {
    const term = searchString.trim();
    if (searchForCoachOnly || term.length < 2 || /^\d+$/.test(term)) {
      setSearchedMemberIds(new Set());
      setSearchingMembers(false);
      return;
    }

    let cancelled = false;
    // Shown from the keystroke, not from the request, so the field reacts
    // immediately instead of sitting still through the debounce.
    setSearchingMembers(true);

    const timeout = setTimeout(async () => {
      try {
        const response = await searchUsers(term, "admin", true);
        if (cancelled) return;
        const ids = Array.isArray(response)
          ? response
              .filter((u: any) => u && !("message" in u) && u.member_id)
              .map((u: any) => u.member_id as string)
          : [];
        setSearchedMemberIds(new Set(ids));
      } catch {
        // Name lookup is a bonus on top of local id matching — never block search.
        if (!cancelled) setSearchedMemberIds(new Set());
      } finally {
        // A superseded lookup must not clear the spinner — the newer one is
        // still running and owns it.
        if (!cancelled) setSearchingMembers(false);
      }
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, [searchString, searchForCoachOnly]);

  useEffect(() => {
    localStorage.setItem("filterDate", formatToIsoDate(filterDate));
    setSelectingActivitySlots(false);
    setSelectedSlotsForActivityCreation([]);
    setCurrentChosenSummaryItem(undefined);
  }, [filterDate]);

  useEffect(() => {
    localStorage.setItem("weekFilterDate", formatToIsoDate(weekFilterDate));
  }, [weekFilterDate]);

  const fetchChosenItems = async ({
    shouldUpdateCurrentSelection = true,
    fetchCourts = false,
    fetchPrices = false,
    fetchMemberType = false,
    fetchPermissions = false,
    fetchCoaches = false,
    fetchSlots = false,
    fetchSlotsAdminByMemberType = false,
    fetchActivities = false,
    fetchLatestCoPlayers = false,
    fetchRehabSlotsAdmin = false,
    fetchRehabSlotsWeekly = false,
    fetchActiveBookingsByMemberId = false,
    fetchActiveBookingsCoPlayer = false,
    fetchActiveActivitiesByMemberId = false,
    fetchDailyComment = false,
  }) => {
    setLoading(true);
    if (!user) return;

    let oldChosenSummaryItem = currentChosenSummaryItem;

    setCurrentChosenSummaryItem(undefined);

    const permission_id = permissions.find(
      (permission) => permission.member_type === chosenUser?.member_type,
    )?.permission_id;

    try {
      const response = await combinedQuery({
        active: true,
        requestor: "admin",
        date: formatToIsoDate(filterDate),
        member_id: chosenUser?.member_id,
        permission_id: permission_id,
        court_type: currentCourtType,
        fetchCourts: fetchCourts,
        fetchRehabSlotsAdmin: fetchRehabSlotsAdmin,
        fetchPrices: fetchPrices,
        fetchMemberType: fetchMemberType,
        fetchPermissions: fetchPermissions,
        fetchCoaches: fetchCoaches,
        fetchSlots: fetchSlots,
        fetchSlotsAdminByMemberType: fetchSlotsAdminByMemberType,
        fetchActivities: fetchActivities,
        fetchLatestCoPlayers: fetchLatestCoPlayers,
        fetchActiveBookingsByMemberId: fetchActiveBookingsByMemberId,
        fetchActiveBookingsCoPlayer: fetchActiveBookingsCoPlayer,
        fetchActiveActivities: fetchActiveActivitiesByMemberId,
        fetchRehabSlotsWeekly: fetchRehabSlotsWeekly,
        fetchDailyComment: fetchDailyComment,
        weekDate: formatToIsoDate(weekFilterDate),
      });
      if (
        fetchMemberType &&
        response.memberType &&
        !("message" in response.memberType)
      ) {
        setMemberType(response.memberType);
      }

      if (
        fetchActiveBookingsByMemberId &&
        response.activeBookings &&
        !("message" in response.activeBookings)
      ) {
        setActiveBookingsForUser(response.activeBookings);
      }
      if (
        fetchActiveBookingsCoPlayer &&
        response.activeBookingsCoPlayer &&
        !("message" in response.activeBookingsCoPlayer)
      ) {
        setActiveCoPlayerBookingsForUser(response.activeBookingsCoPlayer);
      }
      if (
        fetchActiveActivitiesByMemberId &&
        response.activeActivities &&
        !("message" in response.activeActivities)
      ) {
        setActiveActivitiesForUser(response.activeActivities);
      }

      if (fetchPrices && response.prices && !("message" in response.prices)) {
        setPrices(response.prices);
      }
      if (
        fetchRehabSlotsAdmin &&
        response.rehabSlots &&
        !("message" in response.rehabSlots)
      ) {
        setRehabSummary(response.rehabSlots);
      }
      if (
        fetchRehabSlotsWeekly &&
        response.rehabSlotsWeekly &&
        !("message" in response.rehabSlotsWeekly)
      ) {
        setRehabSummaryWeekly(response.rehabSlotsWeekly);
      }

      if (
        fetchPermissions &&
        response.permissions &&
        !("message" in response.permissions)
      ) {
        setPermissions(response.permissions);
      }
      if (fetchCourts && response.courts && !("message" in response.courts)) {
        setCourts(response.courts);
      }

      if (
        fetchActivities &&
        response.activities &&
        !("message" in response.activities)
      ) {
        setActivities(response.activities);
      }
      if (
        fetchCoaches &&
        response.coaches &&
        !("message" in response.coaches)
      ) {
        setCoaches(response.coaches);
      }
      if (fetchSlots && response.slots && !("message" in response.slots)) {
        setSummaries(response.slots);
      }
      if (
        fetchSlotsAdminByMemberType &&
        response.slotsAdminByMemberType &&
        !("message" in response.slotsAdminByMemberType)
      ) {
        setUserSummaries(response.slotsAdminByMemberType);

        if (oldChosenSummaryItem !== undefined) {
          // Find the updated slot within the new summaries
          let updatedSlot: ISummaryItem | undefined;

          const matchingSummary = response.slotsAdminByMemberType.find(
            (summary: ISummary) =>
              summary.court_id === currentChosenCourt.court_id,
          );
          const matchingSlot = matchingSummary?.slots.find(
            (slot: ISummaryItem) =>
              slot.start_time === oldChosenSummaryItem!!.start_time,
          );
          if (matchingSlot) {
            updatedSlot = matchingSlot;
          }

          if (updatedSlot && shouldUpdateCurrentSelection) {
            setCurrentChosenSummaryItem(updatedSlot);
          }
        }
      }
      if (
        fetchLatestCoPlayers &&
        response.latestCoPlayers &&
        !("message" in response.latestCoPlayers)
      ) {
        setLatestCoPlayersForUser(response.latestCoPlayers);
      }

      if (
        fetchDailyComment &&
        response.dailyComment &&
        !("message" in response.dailyComment)
      ) {
        switch (currentCourtType) {
          case "INDOOR":
            setIndoorComment(response.dailyComment);
            break;
          case "OUTDOOR":
            setOutdoorComment(response.dailyComment);
            break;
          case "REHAB":
            setRehabComment(response.dailyComment);
            break;
          default:
            break;
        }
      }

      setLoading(false);
    } catch (error: any) {
      toast.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    let firstRun = true;

    const fetchItemsIfNeeded = () => {
      if (
        !isBookingInitiatedRef.current &&
        !showHandleBookingPopup &&
        !chosenUser &&
        showBookActivityPopup === false
      ) {
        fetchChosenItems({ fetchSlots: true });
      }

      timeoutRef.current = setTimeout(fetchItemsIfNeeded, 60000);
    };

    const startTimeout = () => {
      timeoutRef.current = setTimeout(fetchItemsIfNeeded, 60000);
    };

    if (firstRun) {
      firstRun = false;
      startTimeout();
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [
    filterDate,
    currentCourtType,
    user,
    chosenUser,
    showBookActivityPopup,
    showHandleBookingPopup,
  ]);

  useEffect(() => {
    if (currentCourtType === "REHAB") {
      fetchChosenItems({
        fetchRehabSlotsWeekly: true,
      });
    }
  }, [weekFilterDate, currentCourtType]);

  useEffect(() => {
    setCurrentChosenSummaryItem(undefined);
  }, [filterDate]);

  useEffect(() => {
    if (user) {
      fetchChosenItems({
        fetchCourts: true,
        fetchPrices: true,
        fetchMemberType: true,
        fetchCoaches: true,
        fetchSlots: true,
        fetchPermissions: true,
        fetchActivities: true,
        fetchRehabSlotsAdmin: true,
        fetchDailyComment: true,
      });
    }
    return () => {};
  }, [user]);

  useEffect(() => {
    let chosenItems: {} = {
      fetchRehabSlotsAdmin: true,
      fetchDailyComment: true,
    };
    if (chosenUser) {
      chosenItems = {
        ...chosenItems,
        fetchSlotsAdminByMemberType: true,
        fetchActiveBookingsByMemberId: true,
        fetchActiveActivitiesByMemberId: true,
        fetchActiveBookingsCoPlayer: true,
      };
    } else {
      chosenItems = {
        ...chosenItems,
        fetchSlots: true,
      };
    }
    fetchChosenItems(chosenItems);
  }, [filterDate, currentCourtType]);

  useEffect(() => {
    switch (currentCourtType) {
      case "INDOOR":
        setOutdoorComment(undefined);
        setRehabComment(undefined);
        break;
      case "OUTDOOR":
        setIndoorComment(undefined);
        setRehabComment(undefined);
        break;
      case "REHAB":
        setIndoorComment(undefined);
        setOutdoorComment(undefined);
        break;
      default:
        break;
    }
  }, [currentCourtType]);

  useEffect(() => {
    fetchChosenItems({
      fetchSlotsAdminByMemberType: true,
      fetchLatestCoPlayers: true,
      fetchActiveBookingsByMemberId: true,
      fetchActiveActivitiesByMemberId: true,
      fetchActiveBookingsCoPlayer: true,
    });
  }, [chosenUser]);

  function getAllMarkedSlots() {
    if (!selectedSlotsForActivityCreation.length) return [];

    // global time window
    const times = selectedSlotsForActivityCreation
      .map((s) => s.start_time)
      .sort();

    const min = times[0];
    const max = times[times.length - 1];

    // which courts are involved
    const selectedCourtIds = new Set(
      selectedSlotsForActivityCreation.map((s) => s.court_id),
    );

    const result: any[] = [];

    slotsToRender.forEach((summary) => {
      if (!selectedCourtIds.has(summary.court_id)) return;

      summary.slots.forEach((slot) => {
        if (slot.start_time >= min && slot.start_time <= max) {
          result.push({
            court_id: summary.court_id,
            start_time: slot.start_time,
            end_time: slot.end_time,
            warning: slot.warning,
          });
        }
      });
    });

    return result;
  }

  const handleBookActivity = async () => {
    if (!chosenUser || !currentChosenSummaryItem) return;
    const member_id = chosenUser.member_id;
    const datetime_start =
      formatDate(filterDate, "yyyy-MM-dd").slice(0, 10) +
      "T" +
      currentChosenSummaryItem.start_time;
    const court_id = currentChosenCourt.court_id;
    try {
      const response = await bookActivity(
        member_id,
        court_id,
        datetime_start,
        "admin",
        true,
      );
      if (response && !("message" in response)) {
        toast.success("Bokning skapad");
        fetchChosenItems({
          fetchSlotsAdminByMemberType: true,
        });
      }
    } catch (error: any) {
      toast.error(error);
    }
  };

  const checkCanHaveAnotherBooking = (datetime_start: string) => {
    const permission = permissions.find(
      (permission) => permission.member_type === chosenUser?.member_type,
    );
    if (!permission || !currentChosenSummaryItem || !chosenUser) return false;
    const [extraHours, extraMinutes, extraSeconds] =
      permission.extra_booking_time.split(":");

    const today = new Date();
    let allBookings = 0;
    activeBookingsForUser.forEach(() => {
      allBookings++;
    });
    activeActivitiesForUser.forEach(() => {
      allBookings++;
    });

    if (allBookings === 0) return true;
    if (allBookings > 1) {
      return false;
    }
    if (allBookings === 1 && permission.extra_booking_time === "23:59:00") {
      return false;
    } else if (
      allBookings === 1 &&
      permission.extra_booking_time !== "23:59:00"
    ) {
      const [hours, minutes, seconds] = datetime_start.split(":");

      const selectedBookingDate = new Date(filterDate);
      selectedBookingDate.setHours(
        Number(hours),
        Number(minutes),
        Number(seconds),
        0,
      );
      const todayExtraBookingTime = new Date(today);
      todayExtraBookingTime.setHours(
        Number(extraHours),
        Number(extraMinutes),
        Number(extraSeconds),
        0,
      );

      const tomorrow = subDays(today, -1);
      tomorrow.setHours(23, 59, 0, 0);
      const todayLateBookingTime = new Date(today);
      todayLateBookingTime.setHours(23, 59, 0, 0);

      if (today > todayExtraBookingTime && selectedBookingDate < tomorrow) {
        return true;
      }
      if (
        today < todayExtraBookingTime &&
        selectedBookingDate < todayLateBookingTime
      ) {
        return true;
      }
    }
    if (allBookings === 1 && activeBookingsForUser.length > 0) {
      //case1
      const booking = activeBookingsForUser[0];
      const bookingDate = parseISO(booking.datetime_start);
      const oneDayBeforeBooking = subDays(bookingDate, 1);

      const extraBookingTimeDayBeforeBooking = new Date(oneDayBeforeBooking);
      extraBookingTimeDayBeforeBooking.setHours(
        Number(extraHours),
        Number(extraMinutes),
        Number(extraSeconds),
        0,
      );
      if (extraBookingTimeDayBeforeBooking < today) return true;
    } else if (allBookings === 1 && activeActivitiesForUser.length > 0) {
      const activity = activeActivitiesForUser[0];
      const activityDate = parseISO(activity.activity.datetime_start);
      const oneDayBeforeActivity = subDays(activityDate, 1);

      const extraBookingTimeDayBeforeBooking = new Date(oneDayBeforeActivity);

      extraBookingTimeDayBeforeBooking.setHours(
        Number(extraHours),
        Number(extraMinutes),
        Number(extraSeconds),
        0,
      );
      if (extraBookingTimeDayBeforeBooking < today) return true;
    }
    return false;
  };

  const handleInitiateBooking = async () => {
    if (!chosenUser || !currentChosenSummaryItem) {
      toast.error("Välj en användare");
      return;
    }
    setShowCreateBookingPopup(true);
    const dateTimeString =
      formatDate(filterDate, "yyyy-MM-dd") +
      "T" +
      currentChosenSummaryItem.start_time;

    const bookingToInitiate: IInitiateBookingSpec = {
      court_id: currentChosenCourt.court_id,
      datetime_start: dateTimeString,
      member_id: chosenUser?.member_id,
      booking_type: BookingEnum.CONTRACT,
    };
    try {
      const initiateBookingResponse = await initiateBooking(bookingToInitiate);
      if (initiateBookingResponse.errors) {
        setShowCreateBookingPopup(false);
      }
      if (initiateBookingResponse) {
        setBookingResponse(initiateBookingResponse);
      }
    } catch (error) {
      toast.error("Error creating booking" + error);
      setShowCreateBookingPopup(false);
    }
  };
  useEffect(() => {
    if (currentChosenSummaryItem) {
      setTimeAndCourtString(
        `${currentChosenSummaryItem?.start_time.substring(
          0,
          5,
        )} - ${currentChosenSummaryItem?.end_time.substring(0, 5)}  ${
          currentChosenCourt.name
        }`,
      );
    } else setTimeAndCourtString("");
  }, [currentChosenSummaryItem]);

  const handleConfirmFromBooking = () => {
    setChosenUser(undefined);
    setUserSummaries([]);
    setCurrentSelectedCoach(undefined);
    setBookingResponse(undefined);
    fetchChosenItems({
      fetchSlots: true,
    });
  };

  const checkUnavailableReason = (
    chosenUser: IUser | undefined,
    slot: ISummaryItem,
    court: ICourt,
    activeBookings: IBooking[],
    activeBookingsAsCoPlayer: ICoPlayerBooking[],
    activeActivitiesForUser: IActivityObject[],
    courts: ICourt[],
  ): string => {
    if (!chosenUser) return "Okänd anledning";

    const slotStart = new Date(
      filterDate.toISOString().split("T")[0] + "T" + slot.start_time,
    );
    const slotMinus30 = new Date(slotStart.getTime() - 30 * 60000);
    const slotPlus30 = new Date(slotStart.getTime() + 30 * 60000);

    // check overlapping activity
    const overlappingActivity = activeActivitiesForUser.find((activity) => {
      const actStart = new Date(activity.activity.datetime_start);
      return actStart >= slotMinus30 && actStart <= slotPlus30;
    });
    if (overlappingActivity) {
      return `${capitalizeWords(
        chosenUser.first_name,
      )} har redan en bokad aktivitet vid ${
        overlappingActivity.activity.datetime_start
      }.`;
    }

    // check overlapping booking on another court
    const conflict = activeBookings.find((b) => {
      const bookingStart = new Date(b.datetime_start);
      return (
        b.court_id !== court.court_id &&
        bookingStart >= slotMinus30 &&
        bookingStart <= slotPlus30
      );
    });
    if (conflict) {
      const courtName =
        courts.find((c) => c.court_id === conflict.court_id)?.name ||
        conflict.court_id;
      return `${capitalizeWords(
        chosenUser.first_name,
      )} har redan en bokning vid ${conflict.datetime_start.slice(
        11,
        16,
      )} på bana ${courtName}.`;
    }

    // check overlapping co-player booking
    const coPlayerConflict = activeBookingsAsCoPlayer.find((b) => {
      const bookingStart = new Date(b.date);
      return (
        b.court_id !== court.court_id &&
        bookingStart >= slotMinus30 &&
        bookingStart <= slotPlus30
      );
    });
    if (coPlayerConflict) {
      const courtName =
        courts.find((c) => c.court_id === coPlayerConflict.court_id)?.name ||
        coPlayerConflict.court_id;
      return `${capitalizeWords(
        chosenUser.first_name,
      )} är medspelare på en bokning vid ${coPlayerConflict.date.slice(
        11,
        16,
      )} på bana ${courtName}.`;
    }

    // fallback: membership restriction
    return `${capitalizeWords(
      chosenUser.first_name,
    )} har inte tillgång till denna tid pga. spelrätt.`;
  };

  useEffect(() => {
    if (
      currentChosenSummaryItem &&
      currentChosenSummaryItem.activity === null
    ) {
      if (chosenUser === undefined) {
        setShowChooseUserPopup(true);
        return;
      }

      let isAvailable = currentChosenSummaryItem.available_for_member_type;
      /** Junior special booking */
      if (
        (chosenUser && chosenUser.member_type === "Junior") ||
        (chosenUser && chosenUser.member_type === "Junior B")
      ) {
        isAvailable = isBookingAllowedForJuniors(
          filterDate,
          currentChosenSummaryItem.start_time,
          currentChosenCourt.name,
          currentChosenSummaryItem.coach_available.length > 0,
        );
      }
      // In the drop-in window any membership can be booked outside its
      // normal times, except Senior spelrätt, which keeps to its own.
      if (
        chosenUser.member_type !== SENIOR_PLAYING_RIGHT &&
        inDropInWindow(
          chosenUser.member_type,
          `${formatDate(filterDate, "yyyy-MM-dd")}T${currentChosenSummaryItem.start_time}`,
          currentChosenCourt?.court_type
        )
      ) {
        isAvailable = true;
      }
      if (chosenUser.frozen) {
        const [hours, minutes, seconds] = currentChosenSummaryItem.start_time
          .split(":")
          .map(Number);

        // Create a Date from filterDate but with the slot's local time
        const slotDate = new Date(filterDate);
        slotDate.setHours(hours, minutes, seconds || 0, 0);

        // Current time
        const now = new Date();

        // If the slot starts in the future → frozen users can't book
        if (slotDate > now) {
          const reason = `${chosenUser.first_name} är fryst och kan endast boka när speltiden har startat eller som medspelare.`;
          setNotAvailableForMemberReason(reason);
          setShowNotAvailableForMember(true);
          return;
        }
      }

      if (!isAvailable) {
        const reason = checkUnavailableReason(
          chosenUser,
          currentChosenSummaryItem,
          currentChosenCourt,
          activeBookingsForUser,
          activeCoPlayerBookingsForUser,
          activeActivitiesForUser,
          courts,
        );
        setNotAvailableForMemberReason(reason);
        setShowNotAvailableForMember(true);
        return;
      }
      if (checkCanHaveAnotherBooking(currentChosenSummaryItem.start_time)) {
        if (currentChosenSummaryItem.booking.length > 0) {
          setShowSemiNoShowWarning(true);
          return;
        } else {
          handleInitiateBooking();
          return;
        }
      } else {
        setShowMaxBookingsWarningPopup(true);
        return;
      }
    } else if (
      currentChosenSummaryItem &&
      currentChosenSummaryItem.activity !== null
    ) {
      setShowBookActivityPopup(true);
    }
  }, [currentChosenSummaryItem]);

  const handleSlotClick = (slot: ISummaryItem, court: ICourt) => {
    if (selectingBookedSlotForMovement) {
      if (selectedBookedSlotForMovement) {
        if (toastIdMoveBooking) {
          toast.dismiss(toastIdMoveBooking);
          setToastIdMoveBooking(null);
        }
        setSelectedEmptySlotForMovement(slot);
        setShowMoveBookingPopup(true);
        setCurrentChosenCourt(court);
      }
      return;
    } else if (selectingForHistory) {
      setSelectedSlotForHistory(slot);
      setCurrentChosenCourt(court);
      setShowSlotHistoryPopup(true);
      return;
    } else if (selectingActivitySlots) {
      setSelectedSlotsForActivityCreation((prevSelectedSlots) => {
        const isSlotSelected = prevSelectedSlots.some(
          (selectedSlot) =>
            selectedSlot.court_id === court.court_id &&
            selectedSlot.start_time === slot.start_time,
        );
        if (isSlotSelected) {
          return prevSelectedSlots.filter(
            (selectedSlot) =>
              selectedSlot.court_id !== court.court_id ||
              selectedSlot.start_time !== slot.start_time,
          );
        } else {
          return [
            ...prevSelectedSlots,
            {
              court_id: court.court_id,
              start_time: slot.start_time,
              end_time: slot.end_time,
              warning: slot.warning,
            },
          ];
        }
      });
    } else {
      setCurrentChosenSummaryItem(slot);
      setCurrentChosenCourt(court);
    }
  };

  const normalizeTimestamp = (ts: string) => {
    // Fix cases like "2026-01-23T13:16:19.649+01:00:00"
    return ts.replace(/(\+\d{2}:\d{2}):\d{2}$/, "$1");
  };
  const handleBokasSlotClick = (slot: any) => {
    setBokasSlot(slot);
    setShowBokasRemovalPopup(true);
  };
  const handleBookedSlotClick = (
    slot: any,
    court: ICourt,
    isSemiNoShow: boolean,
  ) => {
    if (selectingBookedSlotForMovement) {
      if (slot.booking[0].status === StatusEnum.SEMI_NO_SHOW) {
        if (selectedBookedSlotForMovement) {
          setSelectedEmptySlotForMovement(slot);
          setCurrentChosenCourt(court);
          setShowMoveBookingPopup(true);
          if (toastIdMoveBooking) {
            toast.dismiss(toastIdMoveBooking);
          }
          return;
        }
        return;
      }
      setSelectedBookedSlotForMovement(slot);
      if (toastIdMoveBooking) {
        toast.update(toastIdMoveBooking, {
          render: "Välj en obokad tid att flytta till",
        });
      }

      return;
    } else if (selectingForHistory) {
      setSelectedSlotForHistory(slot);
      setCurrentChosenCourt(court);
      setShowSlotHistoryPopup(true);
      return;
    } else if (selectingActivitySlots) {
      setSelectedSlotsForActivityCreation((prevSelectedSlots) => {
        const isSlotSelected = prevSelectedSlots.some(
          (selectedSlot) =>
            selectedSlot.court_id === court.court_id &&
            selectedSlot.start_time === slot.start_time,
        );
        if (isSlotSelected) {
          return prevSelectedSlots.filter(
            (selectedSlot) =>
              selectedSlot.court_id !== court.court_id ||
              selectedSlot.start_time !== slot.start_time,
          );
        } else {
          return [
            ...prevSelectedSlots,
            {
              court_id: court.court_id,
              start_time: slot.start_time,
              end_time: slot.end_time,
              warning: slot.warning,
            },
          ];
        }
      });
    } else {
      setSelectedSlotToHandle(slot);
      setShowHandleBookingPopup(true);
      setSelectedSlotIsSemiNoShow(isSemiNoShow);
    }
  };
  const handleActivitySlotClick = (slot: any, court: ICourt) => {
    if (selectingBookedSlotForMovement) {
      toast.error("Bokning kan inte flyttas till en aktivitet");
      return;
    }
    if (selectingForHistory) {
      setSelectedSlotForHistory(slot);
      setCurrentChosenCourt(court);
      setShowSlotHistoryPopup(true);
      return;
    }
    setCurrentChosenSummaryItem(slot);
    setCurrentChosenCourt(court);
  };

  const handleToggleCourtType = (type: "INDOOR" | "OUTDOOR" | "REHAB") => {
    // The rehab grid is driven by weekFilterDate, which only ever moves when
    // its own week picker is used — it does not follow filterDate. So arriving
    // from Inne/Ute on a day in a different week left the two out of step, and
    // AdminRehabView's range check pulled the date back to whichever Monday
    // the picker was last left on. Point the week at the day being viewed.
    if (type === "REHAB") {
      setWeekFilterDate(getMondayOfWeek(filterDate));
    }
    setCurrentCourtType(type);
  };

  const handleSearchBookings = (e: any) => {
    setSearchString(e.target.value);
  };

  const handleUserSelection = () => {
    setSelectingActivitySlots(false);
    setSelectedSlotsForActivityCreation([]);
    if (chosenUser) {
      setChosenUser(undefined);
      setUserSummaries([]);
      fetchChosenItems({
        fetchSlots: true,
      });
    } else {
      setShowChooseUserPopup(true);
    }
  };

  const checkChosenSlot = (slot: any, court: ICourt) => {
    return (
      slot.start_time === currentChosenSummaryItem?.start_time &&
      court.court_id === currentChosenCourt.court_id
    );
  };

  const slotsToRender = userSummaries.length > 0 ? userSummaries : summaries;

  const renderSlotRow = (
    slot: ISummaryItem,
    index: number,
    court: ICourt,
    summaryForCourt: ISummaryItem[],
  ) => {
    const time = slot.start_time.substring(0, 5);
    const hasBooking = slot.booking.length > 0;
    const isPendingBooking =
      hasBooking && slot.booking[0].status === StatusEnum.PENDING;
    const booking = slot.booking[0];
    const activity = slot.activity;
    const hasActivity = activity !== null;
    let isAvailable = slot.available_for_member_type === true;

    /**Junior special availablility*/
    if (
      (chosenUser && chosenUser.member_type === "Junior") ||
      (chosenUser && chosenUser.member_type === "Junior B")
    ) {
      isAvailable = isBookingAllowedForJuniors(
        filterDate,
        slot.start_time,
        court.name,
        slot.coach_available.length > 0,
      );
    } else if (chosenUser && chosenUser.member_type === "Junior spelrätt ") {
      isAvailable = isBookingAllowedForJuniorPlayRight(
        filterDate,
        slot.start_time,
        isAvailable,
      );
    }

    const hasCoach = hasBooking && booking.coach_id.length > 0;
    const bookingCoachIsHittingPartner =
      hasCoach &&
      !!coaches?.find((c) => c.coach_id === booking.coach_id[0])
        ?.is_hitting_partner;
    const currentDateTime = new Date();
    const currentDateStart = startOfDay(currentDateTime);
    const filterDateStart = startOfDay(filterDate);
    let currentSelectedUserClass = "";
    let pushDown15pxClass = "";
    const hasWarning = slot.warning && slot.warning !== "";
    const previousSlot = index > 0 ? summaryForCourt[index - 1] : null;

    if ((court.name === "B25" || court.name === "B26") && previousSlot) {
      const previousSlotStartTime = new Date(
        `${formatDate(filterDate, "yyyy-MM-dd")}T${previousSlot.start_time}`,
      );
      const currentSlotStartTime = new Date(
        `${formatDate(filterDate, "yyyy-MM-dd")}T${slot.start_time}`,
      );

      const timeDifferenceInMinutes =
        (currentSlotStartTime.getTime() - previousSlotStartTime.getTime()) /
        (1000 * 60);

      if (timeDifferenceInMinutes === 75) {
        pushDown15pxClass = "push-down-15px";
      }
    }
    let matchesSearchString = false;

    const slotStartTime = new Date(
      `${formatDate(filterDate, "yyyy-MM-dd")}T${slot.start_time}`,
    );
    const slotEndTime = new Date(
      `${formatDate(filterDate, "yyyy-MM-dd")}T${slot.end_time}`,
    );
    const isInPast =
      isBefore(slotEndTime, currentDateTime) ||
      isBefore(filterDateStart, currentDateStart);
    const hasStarted = isBefore(slotStartTime, currentDateTime);

    let textColor = "";
    if (hasBooking && chosenUser) {
      if (booking.member_id === chosenUser?.member_id) {
        textColor = "primary-text";
      } else {
        textColor = "secondary-text";
      }
    } else {
      if (!hasActivity && isAvailable) {
        textColor = "primary-text";
      } else {
        textColor = "secondary-text";
      }
    }

    let isSemiNoShow = false;
    let semiNoshowClass = "";

    let finalPrizeOverZero = false;
    if (hasBooking) {
      finalPrizeOverZero = booking.final_price.some((p) => p.price > 0);
      if (finalPrizeOverZero) {
      }
      if (booking.status === StatusEnum.SEMI_NO_SHOW) {
        isSemiNoShow = true;
        semiNoshowClass = "semi-no-show-slot";
      }
    }

    const coach =
      hasCoach &&
      coaches?.find((coach) => coach.coach_id === booking.coach_id[0]);
    const coachName = coach && coach.first_name + " " + coach.last_name;
    if (searchString && hasBooking) {
      if (searchForCoachOnly) {
        matchesSearchString =
          (hasCoach && booking.coach_id[0].includes(searchString)) ||
          (coachName &&
            coachName.toLowerCase().includes(searchString.toLowerCase()))
            ? true
            : false;
      } else {
        matchesSearchString =
          booking.member_id.includes(searchString) ||
          booking.member_name
            .toLowerCase()
            .includes(searchString.toLowerCase()) ||
          (booking.co_players &&
            booking.co_players.some(
              (player) =>
                player.member_id.includes(searchString) ||
                searchedMemberIds.has(player.member_id),
            )) ||
          (booking.guests &&
            booking.guests.some(
              (guest) =>
                guest.member_id !== "guest" &&
                (guest.member_id.includes(searchString) ||
                  searchedMemberIds.has(guest.member_id)),
            ));
      }
    } else if (searchString && hasActivity) {
      matchesSearchString = activity.participants.some(
        (participant) =>
          participant.member_id.includes(searchString) ||
          searchedMemberIds.has(participant.member_id),
      );
    }

    if (currentSelectedCoach) {
      matchesSearchString =
        (slot.coach_available.find(
          (coach) => coach === currentSelectedCoach.coach_id,
        ) !== undefined &&
          isAvailable &&
          !isInPast &&
          !hasActivity &&
          !hasBooking) ||
        (hasActivity &&
          slot.activity.coach_id &&
          slot.activity.coach_id.some(
            (coach) => coach === currentSelectedCoach.coach_id,
          ));
    }

    const matchesClass = matchesSearchString
      ? "matches-search"
      : searchString.length > 0 || currentSelectedCoach !== undefined
        ? "no-match"
        : "";

    if (hasBooking && chosenUser) {
      currentSelectedUserClass =
        (chosenUser.first_name + " " + chosenUser.last_name ===
          slot.booking[0].member_name &&
          chosenUser.member_id === slot.booking[0].member_id) ||
        (slot.booking[0].co_players &&
          slot.booking[0].co_players.some(
            (player) => player.member_id === chosenUser.member_id,
          ))
          ? "selected-user"
          : "";
    }

    let selectedClass = "";
    const isSelectedForActivityCreation = selectedSlotsForActivityCreation.some(
      (selectedSlot) =>
        selectedSlot.court_id === court.court_id &&
        selectedSlot.start_time === slot.start_time,
    );
    const isInInervalForActivityCreation =
      selectedSlotsForActivityCreation.some((selectedSlot) => {
        const allSelectedSlots = selectedSlotsForActivityCreation;

        const earliestStartTime = Math.min(
          ...allSelectedSlots.map((slot) =>
            new Date(`1970-01-01T${slot.start_time}`).getTime(),
          ),
        );
        const latestStartTime = Math.max(
          ...allSelectedSlots.map((slot) =>
            new Date(`1970-01-01T${slot.start_time}`).getTime(),
          ),
        );

        const currentSlotTime = new Date(
          `1970-01-01T${slot.start_time}`,
        ).getTime();

        const isCourtSelected = selectedSlotsForActivityCreation.some(
          (slot) => slot.court_id === court.court_id,
        );

        return (
          isCourtSelected &&
          currentSlotTime >= earliestStartTime &&
          currentSlotTime <= latestStartTime
        );
      });

    if (checkChosenSlot(slot, court)) {
      selectedClass = "selected-slot";
    }
    // if (slot.end_time > "22:00:00") {
    //   return null;
    // }
    // if (
    //   court.court_type === "OUTDOOR" &&
    //   slot.start_time >= "20:00:00" &&
    //   !hardcodeDateIsInRangeApr20Aug21(filterDate) &&
    //   !hasBooking
    // ) {
    //   return null; // Skip rendering this slot
    // }
    if (loading) {
      return (
        <tr key={index}>
          <td>
            <div className={`summary-item-wrapper ${pushDown15pxClass} `}>
              <div className="text-m summary-content-wrapper"></div>
            </div>
          </td>
        </tr>
      );
    }
    if (isPendingBooking) {
      return (
        <tr key={index}>
          <td
            onClick={() => {
              selectingForHistory
                ? handleBookedSlotClick(slot, court, false)
                : handleBokasSlotClick(slot);
            }}
          >
            <div
              className={`summary-item-wrapper ${pushDown15pxClass} booking-in-progress pointer`}
            >
              <div className="text-m summary-content-wrapper">Bokas...</div>
            </div>
          </td>
        </tr>
      );
    }
    if (
      (hasActivity && chosenUser && !isInPast) ||
      (hasActivity &&
        chosenUser &&
        activity.participants &&
        activity.participants.some(
          (participant) => chosenUser.member_id === participant.member_id,
        )) ||
      (hasActivity && !chosenUser)
    ) {
      const activityName = activity.name.split("%-%")[0];
      const truncatedName =
        activityName.length > 20
          ? `${activityName.substring(0, 19)}..`
          : activityName;
      const activityHasPrice =
        activity.price > 0 &&
        activity.participants.some(
          (participant) =>
            participant.status !== StatusEnum.PAID &&
            participant.status !== StatusEnum.PAID_NOT_CHECKED_IN &&
            participant.status !== StatusEnum.PAID_NO_SHOW,
        );

      if (activity.participants.length >= activity.participants_limit) {
        return (
          <tr key={index}>
            <td>
              <div
                className={`summary-item-wrapper ${activity.color} ${matchesClass} pointer  ${pushDown15pxClass} `}
                onClick={() => handleActivitySlotClick(slot, court)}
              >
                <div className="text-m summary-content-wrapper">
                  <div className="text-m">{`${time}`}</div>
                  <span>{truncatedName}</span>
                </div>

                {activity.comment && (
                  <i className="fa-regular fa-circle-info comment-icon"></i>
                )}
                {activityHasPrice && (
                  <i className="fa-regular fa-sack-dollar inclueds-prize"></i>
                )}
              </div>
            </td>
          </tr>
        );
      }

      if (
        activity.participants &&
        activity.participants.some(
          (participant) => participant.member_id === chosenUser?.member_id,
        )
      ) {
        return (
          <tr key={index}>
            <td>
              <div
                className={`summary-item-wrapper ${matchesClass} selected-slot pointer  ${pushDown15pxClass} `}
                onClick={() => handleActivitySlotClick(slot, court)}
              >
                <div className="text-m summary-content-wrapper">
                  <div className="text-m">{`${time}`}</div>
                  <span>Aktivitet</span>
                </div>
                {activity.comment && (
                  <i className="fa-regular fa-circle-info comment-icon"></i>
                )}
                {activityHasPrice && (
                  <i className="fa-regular fa-sack-dollar inclueds-prize"></i>
                )}
              </div>
            </td>
          </tr>
        );
      } else {
        return (
          <tr key={index}>
            <td>
              <div
                className={`summary-item-wrapper ${matchesClass} ${activity.color} pointer  ${pushDown15pxClass} `}
                onClick={() => handleActivitySlotClick(slot, court)}
              >
                <div className="text-m summary-content-wrapper">
                  <div className="text-m">{`${time}`}</div>
                  <span>{truncatedName}</span>
                </div>
                {activity.comment && (
                  <i className="fa-regular fa-circle-info comment-icon"></i>
                )}
                {activityHasPrice && (
                  <i className="fa-regular fa-sack-dollar inclueds-prize"></i>
                )}
              </div>
            </td>
          </tr>
        );
      }
    }

    const coachAvailable = slot.coach_available.length > 0;
    const availableCoachObjs = slot.coach_available
      .map((id) => coaches?.find((c) => c.coach_id === id))
      .filter((c): c is ICoach => Boolean(c));
    const hasRegularCoach = availableCoachObjs.some(
      (c) => !c.is_hitting_partner,
    );
    const hasHittingPartner = availableCoachObjs.some(
      (c) => c.is_hitting_partner,
    );
    const statusClassMap: any = {
      [StatusEnum.CONFIRMED]: "has-booking",
      [StatusEnum.CHECKED_IN]: "checked-in-slot",
      [StatusEnum.NO_SHOW]: "no-show-slot",
      [StatusEnum.SEMI_NO_SHOW]: "semi-no-show-slot",
      [StatusEnum.CANCELLED]: "canceled-slot",
      [StatusEnum.PAID]: "paid-slot",
      [StatusEnum.PAID_NOT_CHECKED_IN]: "paid-not-checked-in-slot",
    };

    const bookingStatusClass = booking?.status
      ? statusClassMap[booking.status]
      : "";

    let truncatedName = "";
    if (hasBooking) {
      truncatedName = capitalizeWords(booking.member_name);
    }
    const nameString =
      truncatedName.replace(/[^A-Z]/g, "").length > 5
        ? `${truncatedName.substring(0, 14)}..`
        : truncatedName.length > 16
          ? `${truncatedName.substring(0, 16)}..`
          : truncatedName;

    return (
      <tr key={index} className={textColor}>
        <td>
          {hasBooking && !isSemiNoShow ? (
            <div
              className={`summary-item-wrapper ${matchesClass} pointer ${bookingStatusClass} ${currentSelectedUserClass}  ${pushDown15pxClass} ${
                isSelectedForActivityCreation ? "highlight-selected" : ""
              } ${isInInervalForActivityCreation ? "highlight-interval" : ""} 
              ${
                slot === selectedBookedSlotForMovement && "marked-for-movement"
              }`}
              onClick={() => {
                handleBookedSlotClick(slot, court, false);
              }}
            >
              <div className="text-m">{`${time}`}</div>

              <div className="text-m slot-icons-wrapper">
                {capitalizeWords(nameString)}
              </div>
              {finalPrizeOverZero &&
                bookingStatusClass !== "paid-slot" &&
                bookingStatusClass !== "paid-not-checked-in-slot" && (
                  <i className="fa-regular fa-sack-dollar inclueds-prize"></i>
                )}
              {hasCoach &&
                (bookingCoachIsHittingPartner ? (
                  <span className="booking-has-hitting">
                    <RacketIcon />
                  </span>
                ) : (
                  <i className="fa-regular fa-user booking-has-coach"></i>
                ))}
              {hasWarning && (
                <i className="fa-regular fa-triangle-exclamation booking-has-warning warning-icon"></i>
              )}
              {booking.comment && (
                <i className="fa-regular fa-circle-info comment-icon"></i>
              )}
            </div>
          ) : isInPast && isSemiNoShow ? (
            <div
              className={`summary-item-wrapper ${selectedClass} ${matchesClass} ${currentSelectedUserClass} ${semiNoshowClass} pointer  ${pushDown15pxClass} `}
              onClick={() => {
                handleBookedSlotClick(slot, court, true);
              }}
            >
              <div className="text-m summary-content-wrapper">
                <div className="text-m">{`${time}`}</div>
                <div className="text-m">{isSemiNoShow && nameString}</div>
              </div>
              {booking.comment && (
                <i className="fa-regular fa-circle-info comment-icon"></i>
              )}
            </div>
          ) : isInPast ? (
            <div
              className={`summary-item-wrapper ${selectedClass} ${matchesClass} ${currentSelectedUserClass} passed-unbooked pointer  ${pushDown15pxClass} `}
              onClick={() => {
                if (selectingForHistory) {
                  handleSlotClick(slot, court);
                }
              }}
            >
              <div className="text-m summary-content-wrapper">
                <div className="text-m">{`${time}`}</div>
              </div>
            </div>
          ) : (
            <div
              className={`summary-item-wrapper ${selectedClass} ${matchesClass} ${semiNoshowClass} ${currentSelectedUserClass} is-available pointer  ${pushDown15pxClass}${
                isSelectedForActivityCreation ? "highlight-selected" : ""
              } ${isInInervalForActivityCreation ? "highlight-interval" : ""}`}
              onClick={
                hasStarted && isSemiNoShow && !chosenUser
                  ? () => handleBookedSlotClick(slot, court, true)
                  : hasStarted && isSemiNoShow && chosenUser
                    ? () => handleSlotClick(slot, court)
                    : () => handleSlotClick(slot, court)
              }
            >
              <div className="text-m summary-content-wrapper">
                <div className="text-m">{`${time}`}</div>
                <div className="text-m">{isSemiNoShow && nameString}</div>
              </div>

              {checkChosenSlot(slot, court) ? (
                <div></div>
              ) : isSemiNoShow ? (
                <>
                  {hasCoach &&
                    (bookingCoachIsHittingPartner ? (
                      <span className="booking-has-coach">
                        <RacketIcon />
                      </span>
                    ) : (
                      <i className="fa-regular fa-user booking-has-coach"></i>
                    ))}
                  {hasWarning && (
                    <i className="fa-regular fa-triangle-exclamation warning-icon"></i>
                  )}
                </>
              ) : coachAvailable ? (
                <>
                  <div className="text-m slot-icons-wrapper">
                    {hasWarning && (
                      <i className="fa-regular fa-triangle-exclamation warning-icon"></i>
                    )}
                    {hasRegularCoach && (
                      <i className="fa-regular fa-user"></i>
                    )}
                    {hasHittingPartner && <RacketIcon />}
                  </div>
                </>
              ) : (
                <>
                  <div className="text-m slot-icons-wrapper">
                    {hasWarning && (
                      <i className="fa-regular fa-triangle-exclamation warning-icon"></i>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </td>
      </tr>
    );
  };

  const getEarliestStartTime = () => {
    let earliestTime = "23:59";

    courts.forEach((court) => {
      const summaryForCourt = slotsToRender.find(
        (summary) => summary.court_id === court.court_id,
      );
      if (summaryForCourt && summaryForCourt.slots.length > 0) {
        const firstSlotTime = summaryForCourt.slots[0].start_time;
        if (firstSlotTime < earliestTime) {
          earliestTime = firstSlotTime;
        }
      }
    });

    return earliestTime;
  };

  const calculateTimeDifference = (earliestTime: string, courtTime: string) => {
    const [earliestHour, earliestMinute] = earliestTime.split(":").map(Number);
    const [courtHour, courtMinute] = courtTime.split(":").map(Number);

    const earliestTotalMinutes = earliestHour * 60 + earliestMinute;
    const courtTotalMinutes = courtHour * 60 + courtMinute;

    return courtTotalMinutes - earliestTotalMinutes;
  };

  const renderCourtColumn = (court: ICourt) => {
    const summaryForCourt = slotsToRender.find(
      (summary) => summary.court_id === court.court_id,
    );

    const firstSlotTime = summaryForCourt?.slots[0]?.start_time || "";

    const timeDifference = calculateTimeDifference(
      getEarliestStartTime(),
      firstSlotTime,
    );

    const pushDownClass = timeDifference > 0 ? `pushed-down-court` : "";

    // No summary for this court on this date - a court created after the
    // date, or one whose summaries were never generated. Render the same
    // placeholder as a summary with no slots, so the column keeps its width
    // and the grid stays aligned instead of collapsing around the gap.
    if (!summaryForCourt || (!summaryForCourt.slots && !loading)) {
      return (
        <td key={court.court_id}>
          <table className="nested-courts-table">
            <tbody>
              <tr>
                <td>
                  <div className="closed-item-wrapper"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      );
    }

    return (
      <td key={court.court_id} className={pushDownClass}>
        <table className="nested-courts-table">
          <tbody>
            {summaryForCourt.slots.map((slot, index) =>
              renderSlotRow(slot, index, court, summaryForCourt.slots),
            )}
            {Number(summaryForCourt.slots?.length) === 0 && !loading && (
              <tr>
                <td>
                  <div className="closed-item-wrapper"></div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </td>
    );
  };

  if (!courts || !summaries || !coaches) {
    return <Spinner />;
  }

  // Keep Hitting Partner wording hidden until at least one coach is flagged as
  // one, so the feature can ship before the person exists.
  const anyHittingPartnerExists = coaches.some((c) => c.is_hitting_partner);
  const coachDropdownLabel = anyHittingPartnerExists
    ? "Tränare & Hitting Partner"
    : "Tränare";

  return (
    <div className="admin-bookings-page-container">
      <div className="admin-bookings-layout print-section">
        <div className="admin-bookings-declarations">
          <div className="admin-bookings-oversight-info-wrapper">
            <h1 className="text-l primary-text">Översikt</h1>
          </div>
          <div className="admin-bookings-declerations-buttons">
            {chosenUser && (
              <div
                className={`chosen-user-info-wrapper text-m ${
                  chosenUser.frozen && "frozen"
                }`}
              >
                <span>
                  {capitalizeWords(chosenUser.first_name)}{" "}
                  {capitalizeWords(chosenUser.last_name)}
                </span>

                <span>({chosenUser.member_id})</span>
                <span> {capitalizeWords(chosenUser.member_type)},</span>

                <span>No shows: {chosenUser.noshow_count}</span>
                {chosenUser.frozen && "- medlem fryst"}
              </div>
            )}
            <button
              className="text-m select-style admin-actions-setting"
              onClick={handleUserSelection}
            >
              {chosenUser ? (
                <div className="chosen-user-wrapper">
                  {capitalizeWords(chosenUser.first_name) +
                    " " +
                    capitalizeWords(chosenUser.last_name)}
                </div>
              ) : (
                <span>Välj medlem</span>
              )}
            </button>
            {currentCourtType !== "REHAB" && (
              <Dropdown
                classes="coaches-select admin-actions-setting"
                width={200}
                height={35}
                bordered
                title={coachDropdownLabel}
                value={
                  currentSelectedCoach ? currentSelectedCoach.coach_id : ""
                }
                onSelect={(value) => {
                  const selectedCoach = coaches?.find(
                    (coach) => coach.coach_id === value,
                  );
                  setCurrentSelectedCoach(selectedCoach || undefined);
                }}
                options={[
                  {
                    value: "",
                    label: currentSelectedCoach
                      ? "Återställ"
                      : coachDropdownLabel,
                  },
                  ...(coaches || []).map((coach) => ({
                    value: coach.coach_id,
                    label:
                      capitalizeWords(coach.first_name) +
                      " " +
                      capitalizeWords(coach.last_name),
                    icon: coach.is_hitting_partner ? (
                      <RacketIcon />
                    ) : (
                      <i className="fa-regular fa-user"></i>
                    ),
                  })),
                ]}
              />
            )}

            <div className="search-input-wrapper">
              <input
                className="search-input text-m admin-actions-setting"
                value={searchString}
                onChange={handleSearchBookings}
                placeholder="Sök"
              />
              <i className="fa-regular fa-magnifying-glass search-icon"></i>
              {searchingMembers && (
                <i
                  className="fa-regular fa-spinner fa-spin search-spinner"
                  title="Hittar matchningar..."
                ></i>
              )}
            </div>
            {currentCourtType !== "REHAB" && (
              <div className="toggle-flex-between">
                <label className="toggle text-m">
                  <input
                    type="checkbox"
                    name="coach"
                    checked={searchForCoachOnly}
                    onChange={(e) => setSearchForCoachOnly(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
                <span className="text-m secondary-text">Sök efter coach</span>
              </div>
            )}
          </div>
        </div>
        <div className="admin-bookings-action-wrapper">
          <div className="bookings-weekday-selector-wrapper">
            <div className="admin-booking-court-type text-m">
              <button
                className={`toggle-button ${
                  currentCourtType === "INDOOR" ? "active" : ""
                }`}
                onClick={() => handleToggleCourtType("INDOOR")}
              >
                Inne
              </button>
              <button
                className={`toggle-button ${
                  currentCourtType === "OUTDOOR" ? "active" : ""
                }`}
                onClick={() => handleToggleCourtType("OUTDOOR")}
              >
                Ute
              </button>
              <button
                className={`toggle-button ${
                  currentCourtType === "REHAB" ? "active" : ""
                }`}
                onClick={() => handleToggleCourtType("REHAB")}
              >
                Rehab-bad
              </button>
            </div>

            {currentCourtType === "REHAB" && (
              <WeekSelector
                value={weekFilterDate}
                onChange={setWeekFilterDate}
                // The week drives the rehab grid; the picked day drives which
                // column is shown. Without this, choosing Thursday moved the
                // week but left the view on Monday.
                onDateSelect={setFilterDate}
                includeWeekdays={false}
                textM
              />
            )}
            <WeekDaySelector
              value={filterDate}
              onChange={setFilterDate}
              includeWeekdays
              textM
              includePicker={currentCourtType !== "REHAB"}
            />
            {!isToday(filterDate) && (
              <a
                className="text-m no-wrap"
                onClick={() => {
                  const today = new Date();
                  setFilterDate(today);
                  if (currentCourtType === "REHAB") {
                    setWeekFilterDate(getMondayOfWeek(today));
                  }
                }}
              >
                Till idag
              </a>
            )}
          </div>
          {currentCourtType !== "REHAB" ? (
            <div className="admin-bookings-add-wrapper">
              {/* <button
                disabled={
                  selectingActivitySlots ||
                  selectingForHistory ||
                  selectingBookedSlotForMovement
                }
                className="text-m"
                onClick={() => {
                  setShowBookRehabPopup(true);
                }}
              >
                Rehab tider
              </button>
              */}

              <button
                className="text-m"
                onClick={() => {
                  if (!selectingActivitySlots) {
                    setShowBulkWarningPopup(true);
                  } else {
                    const allMarked = getAllMarkedSlots();
                    setSelectedSlotsForActivityCreation(allMarked);
                    setShowCreateSlotWarningPopup(true);
                  }
                }}
              >
                Lägg till varning
              </button>
              <button
                disabled={selectingForHistory || selectingBookedSlotForMovement}
                className="text-m"
                onClick={() => setShowCreateActivityPopup(true)}
              >
                Skapa aktivitet
              </button>
              <button
                disabled={selectingForHistory || selectingBookedSlotForMovement}
                className="text-m"
                onClick={() => {
                  if (selectingActivitySlots) {
                    setSelectedSlotsForActivityCreation([]);
                  }
                  setSelectingBookedSlotForMovement(false);
                  setSelectingActivitySlots(!selectingActivitySlots);
                  setSelectingForHistory(false);
                }}
              >
                {selectingActivitySlots ? "Avbryt markering" : "Markera fält"}
              </button>

              <button
                disabled={
                  selectingActivitySlots || selectingBookedSlotForMovement
                }
                className="text-m"
                onClick={() => {
                  setSelectingBookedSlotForMovement(false);
                  setSelectingActivitySlots(false);
                  setSelectingForHistory(!selectingForHistory);
                }}
              >
                {selectingForHistory ? "Avbryt Historik" : "Historik"}
              </button>
              <button
                disabled={selectingActivitySlots || selectingForHistory}
                className="text-m"
                onClick={() => {
                  setSelectingForHistory(false);
                  setSelectingActivitySlots(false);
                  setSelectingBookedSlotForMovement(
                    !selectingBookedSlotForMovement,
                  );

                  if (!selectingBookedSlotForMovement) {
                    const id = toast.info("Markera bokning att flytta", {
                      autoClose: false,
                    });
                    setToastIdMoveBooking(id);
                  } else {
                    setSelectedBookedSlotForMovement(undefined);
                    if (toastIdMoveBooking) {
                      toast.dismiss(toastIdMoveBooking);
                      setToastIdMoveBooking(null);
                    }
                  }
                }}
              >
                {selectingBookedSlotForMovement
                  ? "Avbryt flyttning"
                  : "Flytta bokning"}
              </button>
            </div>
          ) : (
            <div className="admin-bookings-add-wrapper">
              <button
                disabled={selectingForRehabHistory || selectingRehabSlots}
                className="text-m"
                onClick={() => {
                  setSelectingForRehabSlotEdit(!selectingForRehabSlotEdit);
                }}
              >
                {selectingForRehabSlotEdit ? "avbryt" : "Redigera slot"}
              </button>
              <button
                disabled={selectingForRehabSlotEdit || selectingRehabSlots}
                className="text-m"
                onClick={() => {
                  setSelectingBookedSlotForMovement(false);
                  setSelectingActivitySlots(false);
                  setSelectingForRehabHistory(!selectingForRehabHistory);
                }}
              >
                {selectingForRehabHistory ? "Avbryt Historik" : "Historik"}
              </button>
              <button
                disabled={selectingForRehabSlotEdit || selectingForRehabHistory}
                className="text-m"
                onClick={() => {
                  setSelectingRehabSlots(!selectingRehabSlots);
                }}
              >
                {selectingRehabSlots ? "Avbryt markering" : "Markera fält"}
              </button>
              <button
                disabled={
                  !selectingRehabSlots || !markedRehabSlotsAreReadyForEdit
                }
                className="text-m"
                onClick={() => {
                  setShowEditMarkedRehabSlots(true);
                }}
              >
                Redigera markering
              </button>
            </div>
          )}
        </div>

        {currentCourtType === "REHAB" &&
        rehabComment &&
        rehabComment.comment !== "No comment" &&
        rehabComment.comment !== "" ? (
          <div className="comment-outer-wrapper">
            <div className="comment-wrapper">
              <i className="fa-regular fa-circle-info comment-icon"></i>
              <h2 className="text-m primary-text">{rehabComment.comment}</h2>
            </div>
          </div>
        ) : currentCourtType === "INDOOR" &&
          indoorComment &&
          indoorComment.comment !== "No comment" &&
          indoorComment.comment !== "" ? (
          <div className="comment-outer-wrapper">
            <div className="comment-wrapper">
              <i className="fa-regular fa-circle-info comment-icon"></i>
              <h2 className="text-m primary-text">{indoorComment.comment}</h2>
            </div>
          </div>
        ) : (
          currentCourtType === "OUTDOOR" &&
          outdoorComment &&
          outdoorComment.comment !== "No comment" &&
          outdoorComment.comment !== "" && (
            <div className="comment-outer-wrapper">
              <div className="comment-wrapper">
                <i className="fa-regular fa-circle-info comment-icon"></i>
                <h2 className="text-m primary-text">
                  {outdoorComment.comment}
                </h2>
              </div>
            </div>
          )
        )}

        {currentCourtType === "REHAB" && rehabSummaryWeekly ? (
          <AdminRehabView
            setFilterDate={setFilterDate}
            rehabIsActive={currentCourtType === "REHAB"}
            filterDate={filterDate}
            rehabSummaryWeekly={rehabSummaryWeekly}
            weekFilterDate={weekFilterDate}
            loading={loading}
            searchString={searchString}
            selectedUser={chosenUser}
            openChooseUserPopup={() => {
              setShowChooseUserPopup(true);
            }}
            refetchRehabSummary={() => {
              fetchChosenItems({
                fetchRehabSlotsWeekly: true,
              });
            }}
            setSelectedUser={(user: IUser | undefined) => setChosenUser(user)}
            handleRehabHistoryClick={(slot: IRehabSummaryItem, date: Date) => {
              setSelectedRehabSlotForHistory(slot);
              setSelectedRehabDateForHistory(date);
              setShowRehabSlotHistoryPopup(true);
            }}
            setIsSelectingForEdit={setSelectingForRehabSlotEdit}
            isSelectingRehabSlots={selectingRehabSlots}
            isSelectingForEdit={selectingForRehabSlotEdit}
            isSelectingForHistory={selectingForRehabHistory}
            showEditMarkedRehabSlots={showEditMarkedRehabSlots}
            setShowEditMarkedRehabSlots={setShowEditMarkedRehabSlots}
            setMarkedRehabSlotsAreReadyForEdit={
              setMarkedRehabSlotsAreReadyForEdit
            }
            setIsSelectingRehabSlots={setSelectingRehabSlots}
          />
        ) : (
          <div className="courts-table-overflow-wrapper">
            <table className="courts-table">
              <thead>
                <tr>
                  {courts.map((court, index) => {
                    if (court.court_id === "10007") {
                      return;
                    }
                    if (court.court_type === currentCourtType)
                      return (
                        <th
                          key={index}
                          className={`text-m secondary-text ${
                            court.name === "B6" && "padding-right-20px"
                          }`}
                        >
                          {court.name}{" "}
                          {court.name === "B27" ? "(hardcourt)" : ""}
                        </th>
                      );
                  })}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {courts.map((court, index) => {
                    if (court.court_id === "10007") {
                      return null;
                    }
                    if (court.court_type === currentCourtType)
                      return renderCourtColumn(court);
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
      <ChooseUserPopup
        showPopup={showChooseUserPopup}
        onClose={() => setShowChooseUserPopup(false)}
        onConfirm={(user) => {
          setChosenUser(user);
        }}
        onCancel={() => setCurrentChosenSummaryItem(undefined)}
        summaryItem={currentChosenSummaryItem}
      />

      <CreateBookingPopup
        showPopup={showCreateBookingPopup}
        filterDate={filterDate}
        courtType={currentCourtType}
        court={currentChosenCourt}
        user={user}
        chosenCoach={currentSelectedCoach}
        timeAndCourtString={timeAndCourtString}
        onConfirm={() => {
          handleConfirmFromBooking();
        }}
        onClose={() => {
          setShowCreateBookingPopup(false);
          setCurrentChosenSummaryItem(undefined);
        }}
        bookingToConfirm={bookingResponse}
        coachesList={currentChosenSummaryItem?.coach_available || []}
        latestCoPlayers={latestCoPlayersForUser}
        coaches={coaches as ICoach[]}
        adminChosenUser={chosenUser}
        permissions={permissions}
        price={currentChosenSummaryItem?.price}
        prices={prices}
        courts={courts}
        isAdmin={true}
      />

      <BookActivityPopup
        showPopup={showBookActivityPopup}
        onClose={() => {
          setShowBookActivityPopup(false);
          if (chosenUser) {
            fetchChosenItems({
              fetchSlotsAdminByMemberType: true,
              shouldUpdateCurrentSelection: false,
            });
          } else {
            fetchChosenItems({
              fetchSlots: true,
            });
          }
        }}
        onConfirm={() => {
          if (chosenUser) {
            fetchChosenItems({
              fetchSlotsAdminByMemberType: true,
            });
          } else {
            fetchChosenItems({
              fetchSlots: true,
            });
          }
        }}
        timeAndCourtString={timeAndCourtString}
        slot={currentChosenSummaryItem as ISummaryItem}
        court={currentChosenCourt}
        user={chosenUser}
        filterDate={filterDate}
        courts={courts}
        coaches={coaches}
        permissions={permissions}
      />
      <AdminHandleBookingPopup
        onClose={() => {
          setShowHandleBookingPopup(false);
          setCurrentChosenSummaryItem(undefined);
        }}
        showPopup={showHandleBookingPopup}
        slot={selectedSlotToHandle as ISummaryItem}
        courts={courts}
        onRefetchComment={() =>
          chosenUser
            ? fetchChosenItems({
                fetchSlotsAdminByMemberType: true,
              })
            : fetchChosenItems({
                fetchSlots: true,
              })
        }
        onConfirm={() =>
          chosenUser
            ? fetchChosenItems({
                fetchSlotsAdminByMemberType: true,
                fetchActiveBookingsByMemberId: true,
                fetchActiveActivitiesByMemberId: true,
              })
            : fetchChosenItems({
                fetchSlots: true,
              })
        }
        coaches={coaches}
        isSemiNoShow={selectedSlotIsSemiNoShow}
        filterDate={filterDate}
        prices={prices}
        permissions={permissions}
      />
      <HandleRehabTimesPopup
        user={user}
        selectedUser={chosenUser}
        showPopup={showBookRehabPopup}
        onClose={() => setShowBookRehabPopup(false)}
        onConfirm={() =>
          fetchChosenItems({
            fetchRehabSlotsAdmin: true,
          })
        }
        rehabSummary={rehabSummary}
        date={filterDate}
      />
      <CreateActivityPopup
        showPopup={showCreateActivityPopup}
        onClose={() => {
          setSelectingActivitySlots(false);
          setSelectedSlotsForActivityCreation([]);
          setShowCreateActivityPopup(false);
        }}
        onConfirm={() =>
          fetchChosenItems({
            fetchSlots: true,
          })
        }
        activities={activities}
        coachesList={coaches}
        courts={courts}
        permissions={permissions}
        selectedSlotsProp={selectedSlotsForActivityCreation}
        filterDate={filterDate}
      />
      <SlotHistoryPopup
        showPopup={showSlotHistoryPopup}
        onClose={() => {
          setShowSlotHistoryPopup(false);
          setSelectedSlotForHistory(undefined);
          setSelectingForHistory(false);
        }}
        onConfirm={() => null}
        start_time={selectedSlotForHistory?.start_time}
        court_id={currentChosenCourt?.court_id}
        courts={courts}
        filterDate={filterDate}
      />
      <RehabSlotHistoryPopup
        showPopup={showRehabSlotHistoryPopup}
        onClose={() => {
          setShowRehabSlotHistoryPopup(false);
          setSelectedRehabSlotForHistory(undefined);
          setSelectingForRehabHistory(false);
        }}
        onConfirm={() => null}
        rehabSlot={selectedRehabSlotForHistory}
        rehabDate={selectedRehabDateForHistory}
      />

      <CreateSlotWarningPopup
        showPopup={showCreateSlotWarningPopup}
        selectedSlotsProp={selectedSlotsForActivityCreation}
        onClose={() => setShowCreateSlotWarningPopup(false)}
        onConfirm={() => {
          setSelectingActivitySlots(false);
          setSelectedSlotsForActivityCreation([]);
          fetchChosenItems({ fetchSlots: true });
        }}
        start_time={selectedSlotForHistory?.start_time}
        court_id={currentChosenCourt?.court_id}
        courts={courts}
        filterDate={filterDate}
      />
      <CreateBulkWarningPopup
        showPopup={showBulkWarningPopup}
        onClose={() => setShowBulkWarningPopup(false)}
        onConfirm={() => {
          fetchChosenItems({ fetchSlots: true });
        }}
        courts={courts}
      />
      <HandleConfirmationPopup
        showPopup={showMaxBookingsWarningPopup}
        onClose={() => {
          setShowMaxBookingsWarningPopup(false);
          setCurrentChosenSummaryItem(undefined);
        }}
        onConfirm={() => {
          handleInitiateBooking();
          setShowMaxBookingsWarningPopup(false);
        }}
        questionText={
          capitalizeWords(chosenUser?.first_name.toString() || "") +
          " har nått max antal bokningar, är du säker på att du vill starta en ny bokning?"
        }
        confirmText={"Boka ändå"}
        denyText={"Avbryt"}
      />
      <HandleConfirmationPopup
        showPopup={showNotAvailableForMember}
        onClose={() => {
          setShowNotAvailableForMember(false);
        }}
        onConfirm={() => {
          handleInitiateBooking();
          setShowNotAvailableForMember(false);
        }}
        questionText={notAvailableForMemberReason}
        confirmText={"Boka ändå"}
        denyText={"Avbryt"}
      />
      <HandleConfirmationPopup
        showPopup={showSemiNoShowWarning}
        onClose={() => setShowSemiNoShowWarning(false)}
        onConfirm={() => {
          handleInitiateBooking();
          setShowSemiNoShowWarning(false);
        }}
        questionText={
          "Vid initiering av bokning kommer befintlig semi no-show att tas bort. Vill du fortsätta?"
        }
        confirmText={"Boka"}
        denyText={"Avbryt"}
      />
      <HandleConfirmationPopup
        showPopup={showBookExtraPopup}
        onClose={() => setShowBookExtraPopup(false)}
        onConfirm={() => {
          if (currentChosenSummaryItem?.activity === null) {
            handleInitiateBooking();
          } else {
            handleBookActivity();
          }
        }}
        questionText={
          "Medlemmen har redan bokat max antal bokningar, eller har inte tillgång till denna tid. Vill fortsätta ändp?"
        }
        confirmText={"Ja"}
        denyText={"Avbryt"}
      />

      <MoveBookingPopup
        showPopup={showMoveBookingPopup}
        onClose={() => {
          setShowMoveBookingPopup(false);
          setSelectingBookedSlotForMovement(false);
          setSelectedBookedSlotForMovement(undefined);
        }}
        onConfirm={() => {
          fetchChosenItems({
            fetchSlots: true,
          });
        }}
        bookedSlot={selectedBookedSlotForMovement}
        slotForMovement={selectedEmptySlotForMovement}
        newCourt={currentChosenCourt}
        courts={courts}
        currentCourtType={currentCourtType}
        filterDate={filterDate}
      />
      <BokasRemovalPopup
        showPopup={showBokasRemovalPopup}
        onClose={() => setShowBokasRemovalPopup(false)}
        onConfirm={() => {
          if (chosenUser) {
            fetchChosenItems({
              fetchSlotsAdminByMemberType: true,
            });
          } else {
            fetchChosenItems({
              fetchSlots: true,
            });
          }
        }}
        slot={bokasSlot as ISummaryItem}
      />
    </div>
  );
}

export default AdminHandleBookings;
